<app-top-ribbon></app-top-ribbon>
<div class="login-image">
  <div class="welcome">
    <h2 class="welcome-text">{{title}}</h2>
    <h3 class="instr-text">{{message}}</h3>
  </div>
</div>
